import styled, { css, keyframes } from "styled-components/macro";
import { themeVariables } from "../../../../themeVariables";

const openAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const closeAnimation = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0.5);
  }
`;

export const DocumentLinkingContainer = styled.div`
  ${(props) =>
    props.menuPosition !== "down-centered"
      ? css`
          position: relative;
        `
      : css`
          position: initial;
        `}
`;

export const StyledContainer = styled.div`
  --opacity-start: 0;
  --opacity-end: ${(props) => (props.actuallyShowLinkingMenu ? 1 : 0)};

  padding: 10px 13px;
  border: 2px solid ${themeVariables.grey3};
  border-radius: 10px;
  background-color: ${themeVariables.menuColorFullscreen};
  box-shadow: ${themeVariables.tinyDropShadow};
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  top: 0;
  width: max-content;
  max-width: 575px;
  pointer-events: none;
  opacity: 0;

  ${({ menuPosition }) => {
    if (menuPosition === "down") {
      return css`
        top: 50px;
        left: auto;
        right: 0;
      `;
    } else if (menuPosition === "down-centered") {
      return css`
        top: 125px;
        left: 40px;
        right: auto;
      `;
    } else {
      return css`
        left: 45px;
        right: auto;
      `;
    }
  }}

  z-index: 4;
  user-select: none;

  #document-linking-menu {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &.opening {
    ${(props) =>
      props.actuallyShowLinkingMenu
        ? css`
            animation: ${openAnimation} 0.3s ease forwards;
            pointer-events: auto;
          `
        : css`
            animation: none;
            opacity: 0;
            pointer-events: none;
          `}
  }

  &.closing {
    ${(props) =>
      props.actuallyShowLinkingMenu
        ? css`
            animation: ${closeAnimation} 0.3s ease forwards;
            pointer-events: none;
          `
        : css`
            animation: none;
            opacity: 0;
            pointer-events: none;
          `}
  }

  &::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: ${themeVariables.menuColorFullscreen};
    border-right: 2px solid ${themeVariables.grey3};
    border-top: 2px solid ${themeVariables.grey3};
    transform: rotate(45deg);
    border-radius: 4px;

    ${({ menuPosition, buttonPosition }) => {
      if (menuPosition === "down") {
        return css`
          top: -9px;
          right: 11px;
          rotate: -90deg;
        `;
      } else if (menuPosition === "down-centered") {
        return css`
          top: -9px;
          left: ${buttonPosition ? `${-buttonPosition}px` : "50%"};
          rotate: -90deg;
        `;
      } else {
        return css`
          top: 6px;
          left: -9px;
          rotate: 180deg;
        `;
      }
    }}
  }
`;

export const LinkInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  p {
    color: ${themeVariables.grey0};
    font-weight: 500;
  }

  .text-button-text {
    color: ${themeVariables.primaryCTAHighContrast};
  }

  svg {
    path {
      fill: ${themeVariables.grey0};
    }
  }
`;
